import { Input } from '@frontapp/ui-kit';
import { useState } from 'react';
import OrganizationInfo from './OrganizationInfo';
import type { Account } from './types';

type Props = {
  account: Account;
};

function Organizations({ account }: Props) {
  const [currentSearch, setCurrentSearch] = useState<string>('');

  const filteredOrganizations = currentSearch
    ? account.organizations.filter((organization) =>
        Object.values(organization)
          .join(' ')
          .toLowerCase()
          .includes(currentSearch.toLowerCase()),
      )
    : account.organizations;

  return (
    <div style={{ margin: '15px 0' }}>
      <div style={{ marginBottom: '15px' }}>
        <Input
          name="info"
          type="text"
          placeholder="Filter organizations"
          iconName="Search"
          value={currentSearch}
          onChange={(value) => setCurrentSearch(value)}
        />
      </div>
      <table className="User__organizations__table">
        <thead>
          <tr>
            <th>Name</th>
            <th># Projects</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {filteredOrganizations
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((organization) => (
              <OrganizationInfo
                key={organization.id}
                organization={organization}
              />
            ))}
        </tbody>
      </table>
    </div>
  );
}

export default Organizations;
